import { useState, useRef, useEffect } from "react";
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faXmark } from '@fortawesome/free-solid-svg-icons'
import Select from "react-select";

function RowList6({data}) {
    const [showMenu, setShowMenu] = useState(false);
    const [modalIsOpen3, setIsOpen3] = useState(false);
    const [loading, setLoading] = useState(false);
    const [crypto, setCrypto] = useState([]);
    const [fiat, setFiat] = useState([]);
    const [stock, setStock] = useState([]);
    const [wallet, setWallet] = useState([]);
    const [assethistory, setAssethistory] = useState([]);
    const menuRef = useRef();
    useEffect(() => {
        function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setShowMenu(false);
        }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ fetchwallet1: true, user : data?.user?.email  })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === "success") {
            setWallet(data.wallet);
            }
        })
        .catch(err => {
            
        })
    }, [data]);
    useEffect(() => {
        fetch(`/coin_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        var coinList = data.data;
        const updatedData = coinList.map((coin, index) => ({
            id: index + 1,
            logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
            name: coin.name,
            type: 'crypto',
            symbol: coin.symbol,
            price: Number(coin.quote.USD.price.toFixed(2)),
            label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,
            value: coin.name,
            amount: 0,
        }));
        setCrypto(updatedData);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {
        fetch(`/stock_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        const stockList = Object.values(data);
        const updatedData = stockList.map((stock, index) => ({
            id: index + 1,
            logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
            name: stock.name,
            type: 'stock',
            symbol: stock.symbol,
            price: Number(stock.price.toFixed(2)),
            label: <><img src={`https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`} alt={stock.symbol} width="20" /> {stock.symbol}</>,
            value: stock.name,
            amount: 0,
        }));
        setStock(updatedData);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {   
        fetch(`/fiat_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        const wantedCurrencies = {
            AUD: 'Australian Dollar',
            CAD: 'Canadian Dollar',
            CHF: 'Swiss Franc',
            CNY: 'Chinese Yuan',
            EUR: 'Euro',
            GBP: 'British Pound',
            INR: 'Indian Rupee',
            JPY: 'Japanese Yen',
            RUB: 'Russian Ruble',
            USD: 'US Dollar',
            ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
            .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
            .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            label: <><img src={`https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`} alt={code} width="20" /> {code}</>,
            value: wantedCurrencies[code],
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
            }));
        
        setFiat(fiatList);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {
        if (!crypto.length && !fiat.length && !stock.length) return;
        const walletMap = wallet.reduce((acc, item) => {
        const key = item.coinName?.trim().toLowerCase();
        acc[key] = parseFloat(item.balance) || 0;
        return acc;
        }, {});
        let total = 0;
        const applyWalletBalance = (list) =>
        list.map(item => {
            const key = item.name?.trim().toLowerCase();
            const matchedBalance = walletMap[key];
            const amount = matchedBalance || 0;
            const value = amount * item.price;
            total += value;
            return {
            ...item,
            amount: matchedBalance || 0
            };
        });
        const merged = [
        ...applyWalletBalance(crypto),
        ...applyWalletBalance(fiat),
        ...applyWalletBalance(stock)
        ];
        const sorted = merged.sort((a, b) => {
        if (b.amount > 0 && a.amount === 0) return 1;
        if (a.amount > 0 && b.amount === 0) return -1;
        return a.name.localeCompare(b.name);
        });
        setAssethistory(sorted);
    }, [crypto, fiat, stock, wallet]);
    const Delete = () => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ deleteCopy: true, id: data.id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }
    const Approve = () => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ approveCopy: true, id: data.id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }
    const darkThemeStyles1 = {
      control: (styles) => ({
        ...styles,
        backgroundColor: "rgb(30, 33, 36)",
        border: "none",
        color: "#fff",
        fontWeight: '600',
      }),
      menu: (styles) => ({
        ...styles,
        backgroundColor: "rgb(30, 33, 36)",
        fontWeight: '600',
      }),
      option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected ? "#151719" : isFocused ? "#151719" : "rgb(30, 33, 36)",
        color: "#fff",
        fontWeight: '600',
      }),
      singleValue: (styles) => ({
        ...styles,
        color: "#fff",
        fontWeight: '600',
      }),
    };
    const [pamount, setPamount] = useState()
    const [passet, setPasset] = useState()
    const [psymbol, setPsymbol] = useState()
    const [pprice, setPprice] = useState();
    const AddProfit = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ addprofit: true, email: data?.user?.email, asset:passet, amount:pamount, price:pprice, symbol:psymbol, activity : "Copy Trade", botname : data.copy.trader_name })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === "success") {
            toast.success(data.result);
            setIsOpen3(false);
            }else{
            toast.error(data.message);
            }
            setLoading(false);
        })
        .catch(err => {
            console.error(err);
            setLoading(false);
        })
    }
    console.log(data)
    return (
        <>
        <tr className="fw-semibold">
            <td>
                <div className='d-flex align-items-center'>
                    <div className='d-flex align-items-center justify-content-center overflow-hidden rounded-2' style={{width: '32px', height: '32px'}}>
                    <img src={`/uploads/${data.copy.trader_photo}`} alt="Expert Image" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                    </div>
                    <span className='ms-2 text-nowrap'>{data.copy.trader_name}</span>
                </div>
            </td>
            <td>
                <div className='d-flex align-items-center'>
                    <div className='d-flex align-items-center justify-content-center rounded-2 text-prime fw-semibold' style={{backgroundColor:'#ffffff0d', width: '32px', height: '32px'}}>
                        <span>{data?.user?.fullname.charAt(0)}</span>
                    </div>
                    <span className='ms-2 text-nowrap'>{data?.user?.fullname}</span>
                </div>
            </td>
            <td className={`text-${data?.status == "2" ? "warning" : "success"} fw-bold`}>{data?.status == "2" ? 'Pending' : 'Following'}</td>
            <td style={{ position: "relative" }}>
                <div
                className="myBtn d-inline-block px-3"
                style={{ cursor: "pointer" }}
                onClick={() => setShowMenu((prev) => !prev)}
                >
                Edit
                </div>
                {showMenu && (
                <div
                    ref={menuRef}
                    className="dropdown-menu-custom"
                    style={{
                    position: "absolute",
                    top: "35px",
                    right: 0,
                    background: "#232528",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    zIndex: 10,
                    minWidth: "120px",
                    padding: "5px",
                    }}
                >
                    {data?.status == "2" && (
                        <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Approve(true)}>
                            Approve
                        </div>
                    )}
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => setIsOpen3(true)}>
                    Add profits
                    </div>
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Delete()}>
                    Delete
                    </div>
                </div>
                )}
            </td>
        </tr>
        <Modal
            isOpen={modalIsOpen3}
            onRequestClose={() => setIsOpen3(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Add profits</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen3(false)} />
            </div>
            <p className="mb-3 mt-2 text-light fw-semibold" style={{fontSize: '15px'}}>Add profits to the user account</p>
            <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User:</label>
            <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input 
                    type="text" 
                    placeholder={data?.user?.email}
                    className="inputNone w-100 py-1"
                    value={data?.user?.email}
                    readOnly
                />
            </div>
            <label className="fw-semibold mb-2 mt-2" style={{fontSize: '14px'}}>Expert:</label>
            <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input 
                    type="text" 
                    placeholder={data.copy.trader_name}
                    className="inputNone w-100 py-1"
                    value={data.copy.trader_name}
                    readOnly
                />
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Profits:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
            <input 
                type="text" 
                placeholder="How much profits do you want to add?" 
                className="inputNone"
                value={pamount}
                onChange={(e) => {setPamount(e.target.value);}}
            />
            <Select 
                options={assethistory}
                placeholder="Assets" 
                value={assethistory.find(opt => opt.value === passet)}
                onChange={opt => (setPasset(opt.value), setPprice(opt.price), setPsymbol(opt.symbol))}
                isSearchable
                styles={darkThemeStyles1}
                className="w-full"
            />
            </div>
            <div className="d-flex align-items-center justify-content-between">
                <p style={{fontSize:'14px'}}>Current profits:</p>
                <p style={{fontSize:'14px'}}>${data?.user?.profit}</p>
            </div>
            <div className={`myBtn bg-prime w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={AddProfit}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add profits'}</div>
        </Modal>
        </>
    )
  }
  
  export default RowList6